import { Route } from "react-router-dom";
import Insights from "@/pages/Insights";
import InsightsPost from "@/pages/InsightsPost";
import { ProtectedRoute } from "@/components/ProtectedRoute";

// Auth-gated INSIGHTS routes — imported by internal + adviser (NOT public: the public/retail
// target has no auth and omits these). Placed inside the same `<Layout>`/`<PublicLayout>`-wrapped
// nested <Routes> as the marketing routes, so it returns a fragment. Must appear BEFORE the
// publicRoutes() `*` NotFound catch-all in the composing <Routes>.
export function insightsRoutes() {
  return (
    <>
      <Route
        path="/insights"
        element={
          <ProtectedRoute>
            <Insights />
          </ProtectedRoute>
        }
      />
      <Route
        path="/insights/:slug"
        element={
          <ProtectedRoute>
            <InsightsPost />
          </ProtectedRoute>
        }
      />
    </>
  );
}
